module.exports = {
    path: "/ingestion",
    component: () => import("@/modules/ingestion/Ingestion.vue"),
    meta: { module: "ig" },
    redirect: { name: 'file-summary' },
    children: [
        {
            name: 'file-summary',
            path: 'file-summary',
            component: () => import('@/modules/ingestion/pages/FileSummary.vue')
        },
        {
            name: 'sufficiency',
            path: 'sufficiency',
            component: () => import('@/modules/ingestion/pages/Sufficiency.vue')
        },
        {
            name: 'scada-coverage-report',
            path: 'coverage',
            component: () => import('@/modules/ingestion/pages/ScadaCoverageReport.vue'),
            redirect: { name: 'coverage-device' },
            children: [
                {
                    name: 'coverage-device',
                    path: 'device',
                    component: () => import('@/modules/ingestion/pages/scadaCoverageReportSubComponents/Device.vue')
                },
                {
                    name: 'coverage-plant',
                    path: 'plant',
                    component: () => import('@/modules/ingestion/pages/scadaCoverageReportSubComponents/Plant.vue')
                },
                {
                    name: 'coverage-fleet',
                    path: 'fleet',
                    component: () => import('@/modules/ingestion/pages/scadaCoverageReportSubComponents/Fleet.vue')
                }
            ]
        },
        {
            name: 'coverage-device-basic',
            path: 'coverage-device-basic/plant/:plantId/device/:deviceId',
            component: () => import('@/modules/ingestion/pages/ReportCoverageLevel0.vue') // TODO: probably makes more sense as a child-route to scada coverage report
        }
    ]
  };



// WEBPACK FOOTER //
// ./src/modules/ingestion/router.js